import formatTableJson from '@/config/tableComponentParams.js'
// import { enbaleDisableStatus } from '@/config/status'
import { publishStatusTag } from '@/config/tag.js'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'iconFileId',
    label: i18n.t('RecipeManage.typeRecipeImg'),
    type: 'image'
  },
  {
    filed: 'name',
    label: i18n.t('RecipeManage.typeRecipeTypeName'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'code',
    label: i18n.t('RecipeManage.typeRecipeID'),
    width: '180px',
    showOverflowTooltip: true
  },
  {
    filed: 'cookbookCount',
    label: i18n.t('RecipeManage.typeRecipeCount'),
    width: '180px',
    sortable: true,
    showOverflowTooltip: true
  },
  {
    filed: 'createTime',
    label: i18n.t('Common.createTime'),
    width: '180px',
    type: 'time',
    sortable: true,
    showOverflowTooltip: true
  }
])
